const SRC = (s) => `${process.env.PUBLIC_URL || ''}/morgan/morgan-icon-${s}.png`;

// Round Morgan icon; srcset keeps it crisp on retina screens at any size.
export const MorganAvatar = ({ size = 28, className = '', testId }) => {
  const base = size <= 32 ? 64 : size <= 64 ? 128 : 256;
  return (
    <img src={SRC(base)} srcSet={`${SRC(base)} 1x, ${SRC(Math.min(base * 2, 512))} 2x`}
         width={size} height={size} alt="Morgan" draggable={false} data-testid={testId}
         className={`inline-block shrink-0 select-none rounded-full object-contain ${className}`}
         style={{ width: size, height: size }} />
  );
};
